import React from 'react';
import {StepProps} from '../../steps';
import {ContractorDataValidationStatus} from '../../../../../api/contractor-api/Contractor';
import {StepFillContractorFields} from './step-fill-contractor-fields';

export const StepFirst: React.FC<StepProps<ContractorDataValidationStatus>> = ({title, setNexCallback, match}) => {
  return <StepFillContractorFields title={title} match={match} setNexCallback={setNexCallback as any} />;
};
